var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile-section" }, [
    _c("div", { staticClass: "profile-section__nav" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "NavigationTabsSmooth",
                {
                  staticClass: "navi-tabs",
                  attrs: { "handle-selection": false }
                },
                _vm._l(_vm.routes, function(label) {
                  return _c(
                    "router-link",
                    {
                      key: label,
                      staticClass: "vs-btn btn stylized",
                      class:
                        _vm.activeRoute === label ? "selected--computed" : "",
                      attrs: {
                        to: { path: _vm.basePath + label },
                        "active-class": "selected"
                      }
                    },
                    [
                      _c("span", { staticClass: "without-name" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("profile.tabs_label.format", {
                              user: _vm.permissions.isOwner
                                ? _vm.$t("profile.tabs_label.my")
                                : _vm.user.profile.firstName +
                                  _vm.$t("profile.tabs_label.apos"),
                              item: _vm.$t("profile.tabs." + label, {
                                count: 2
                              })
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "with-name" }, [
                        _vm._v(
                          _vm._s(_vm.$t("profile.tabs." + label, { count: 2 }))
                        )
                      ])
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "profile-section__main" },
      [
        _c(
          "keep-alive",
          [
            _vm.$route.meta.requestedTab
              ? _c("router-view", {
                  key: _vm.$route.meta.requestedTab,
                  attrs: {
                    type: _vm.activeRoute,
                    "profile-owner": _vm.user,
                    permissions: _vm.permissions
                  }
                })
              : _vm.activeRoute
              ? _c(_vm.fallbackComponent, {
                  key: "static-" + _vm.activeRoute,
                  tag: "component",
                  attrs: {
                    type: _vm.activeRoute,
                    "profile-owner": _vm.user,
                    permissions: _vm.permissions
                  }
                })
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }